module.exports = __webpack_public_path__ + "img/3-2.83ad1aa9.png";